module.exports = __webpack_public_path__ + "static/img/necklace.c8ef0f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/necklace.png
// module id = pMyc
// module chunks = 1